<div class="modal-content flex flex-column gap-10 p-6">
  <div class="flex items-center justify-between">
    <h5>Payment Terms & Conditions</h5>
    <button
      type="button"
      class="close mr-1.5"
      data-dismiss="modal"
      aria-label="Close"
      (click)="onAgree()"
    >
      <cj-icon icon="times" pack="font-awesome-solid"></cj-icon>
    </button>
  </div>

  <div class="flex flex-column">
    <div [innerHTML]="content"></div>
  </div>

  <div class="flex justify-end gap-2.5">
    <button cjButton (click)="onAgree(true)">
      I agree and understand
    </button>
  </div>
</div>
